module.exports = __webpack_public_path__ + "img/article_11_2.904e53e7.webp";